<template>
  <div class="skeleton-loader">
    <!-- 骨架屏头部 -->
    <div class="skeleton-header">
      <div class="skeleton-breadcrumb"></div>
      <div class="skeleton-title"></div>
    </div>

    <!-- 骨架屏主内容 -->
    <div class="skeleton-content">
      <!-- 左侧参数面板骨架 -->
      <aside class="skeleton-sidebar">
        <div class="skeleton-panel-title"></div>
        <div class="skeleton-param" v-for="i in 4" :key="i">
          <div class="skeleton-param-label"></div>
          <div class="skeleton-param-control"></div>
        </div>
        <div class="skeleton-button"></div>
      </aside>

      <!-- 右侧可视化区域骨架 -->
      <main class="skeleton-main">
        <div class="skeleton-visualization">
          <div class="skeleton-chart"></div>
        </div>
        <div class="skeleton-actions">
          <div class="skeleton-action-btn" v-for="i in 3" :key="i"></div>
        </div>
      </main>
    </div>

    <!-- 骨架屏底部 -->
    <div class="skeleton-footer">
      <div class="skeleton-section-title"></div>
      <div class="skeleton-text-line" v-for="i in 3" :key="i"></div>
    </div>
  </div>
</template>

<script setup>
// 骨架屏组件，用于 Toy 加载时的占位显示
</script>

<style scoped>
.skeleton-loader {
  padding: 2rem;
  background-color: #f5f5f5;
  min-height: 100vh;
}

/* 骨架屏动画 */
@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.skeleton-loader > * {
  background: linear-gradient(
    90deg,
    #f0f0f0 0%,
    #f8f8f8 50%,
    #f0f0f0 100%
  );
  background-size: 1000px 100%;
  animation: shimmer 2s infinite;
  border-radius: 8px;
}

/* 头部 */
.skeleton-header {
  margin-bottom: 2rem;
}

.skeleton-breadcrumb {
  width: 200px;
  height: 20px;
  margin-bottom: 1rem;
}

.skeleton-title {
  width: 300px;
  height: 36px;
}

/* 主内容 */
.skeleton-content {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

/* 侧边栏 */
.skeleton-sidebar {
  background-color: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.skeleton-panel-title {
  width: 120px;
  height: 24px;
  margin-bottom: 1.5rem;
}

.skeleton-param {
  margin-bottom: 1.5rem;
}

.skeleton-param-label {
  width: 100px;
  height: 16px;
  margin-bottom: 0.5rem;
}

.skeleton-param-control {
  width: 100%;
  height: 32px;
}

.skeleton-button {
  width: 100%;
  height: 40px;
  margin-top: 1rem;
}

/* 主区域 */
.skeleton-main {
  background-color: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.skeleton-visualization {
  margin-bottom: 1.5rem;
}

.skeleton-chart {
  width: 100%;
  height: 400px;
}

.skeleton-actions {
  display: flex;
  gap: 1rem;
}

.skeleton-action-btn {
  width: 80px;
  height: 36px;
}

/* 底部 */
.skeleton-footer {
  background-color: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.skeleton-section-title {
  width: 150px;
  height: 24px;
  margin-bottom: 1rem;
}

.skeleton-text-line {
  width: 100%;
  height: 16px;
  margin-bottom: 0.75rem;
}

.skeleton-text-line:last-child {
  width: 70%;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .skeleton-content {
    grid-template-columns: 280px 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .skeleton-loader {
    padding: 1rem;
  }

  .skeleton-content {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .skeleton-chart {
    height: 300px;
  }
}
</style>
